import { createRouter, createWebHistory } from 'vue-router';
var routes = [
    {
        path: '/',
        name: 'home',
        component: function () { return import('../views/HomeView.vue'); },
        children: [
            {
                path: '/',
                name: 'index',
                component: function () { return import('../views/contents/index.vue'); },
            },
            {
                path: '/subscribe',
                name: 'subscribe',
                component: function () { return import('../views/contents/subscribePage.vue'); },
            },
            {
                path: '/tuijian',
                name: 'tuijian',
                component: function () { return import('../views/contents/tuijian.vue'); },
            },
            {
                path: '/channel',
                name: 'channel',
                component: function () { return import('../views/contents/channel.vue'); },
            },
            {
                path: '/userInfo',
                name: 'userInfo',
                component: function () { return import('../views/userInfo/UserInfoPage.vue'); },
            },
            {
                path: '/changePassword',
                name: 'changePassword',
                component: function () { return import('../views/userInfo/ChangePassword.vue'); },
            },
            {
                path: '/recharge',
                name: 'recharge',
                component: function () { return import('../views/buy/recharge.vue'); },
            },
            {
                path: '/PurchaseHistory',
                name: 'PurchaseHistory',
                component: function () { return import('../views/userInfo/PurchaseHistory.vue'); },
            }, {
                path: '/video-player',
                name: 'video-player',
                component: function () { return import('../views/player/PageVuePlay.vue'); },
            },
            {
                path: '/video-player-demo',
                name: 'video-player-demo',
                component: function () { return import('../components/player/VideoPlayerDemo.vue'); },
            }
        ],
    },
    {
        path: '/login',
        name: 'login',
        component: function () { return import('../views/identity/login.vue'); },
    },
    {
        path: '/register',
        name: 'register',
        component: function () { return import('../views/identity/register.vue'); },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: function () { return import('../views/identity/forgot-password.vue'); },
    },
    {
        path: '/audio-player',
        name: 'audio-player',
        component: function () { return import('../views/player/AudioPlayer.vue'); },
    },
];
var router = createRouter({
    history: createWebHistory(),
    routes: routes
});
export default router;
